import {AnyAction} from "redux";
import {SET_EVENT_ID} from "../actions/action";
import * as _ from 'lodash';
import {getMiniGames, IMiniGame} from "../../data/data";
import {createSelector} from "reselect";


//  define selectors

export const getEventID = state => state.event;

/**
 * get the data object for a event
 */
export const getMiniGameData = createSelector(

    [getEventID],

    (event_id: string) =>
    {
        const events: IMiniGame[] = getMiniGames();

        return _.find(events, ['id', event_id])
    }
);

//  define the initial state

const initialState: string = null;


/**
 * reducer: set the current event ID
 * @param {number} state
 * @param {AnyAction} action
 * @returns {number}
 */
export function event(state: string = initialState, action: AnyAction): string
{
    switch (action.type)
    {
        case SET_EVENT_ID:
        {
            const {payload} = action;
            const {event_id} = payload;

            return event_id;
        }

        default:

            return state;
    }
}



// WEBPACK FOOTER //
// ./src/ts/store/reducers/event.ts